import { Fee } from "./Fee";
import { Guid } from "./Guid";
import { ItemPricing } from "./ItemPricing";
import { QuoteDetailSubline } from "./QuoteDetailSubline";

export class QuoteDetail {
  constructor() {
    this.OrderDetailRowPointer = Guid.newGuid();
    this.Item = "";
    this.ConfigString = "";
    this.ProductImage = "";
    this.Fees = [];
    this.Index = 0;
    this.LineNote = "";
    this.AssemblyDetails = [];
    this.AssemblyDetailsDB = "";
    this.LineType = "";
    this.BreakQty1 = 1;
    this.BreakQty2 = null;
    this.BreakQty3 = null;
    this.BreakQty4 = null;
    this.BreakQty5 = null;
    
    this.Description = "";
    this.ShortDesc = "";
    this.Price = 0.0;
    this.QtyOrdered = 0;
    this.ExtPrice = 0.0;
    this.ListPrice = 0.0;
    this.PortalStatus = "";
    this.DueDate = null;
    this.TrackingNumber = "";
    this.CarrierCode = "";
    this.ShipDate = "";
    this.EstShipDate = "";
    this.RefNum = "";
    this.Followed = false;
    this.SourceType = "";
    this.HTSCode = "";
    this.Country = "";
    this.BreakPrice1 = 0.0;
    this.BreakPrice2 = 0.0;
    this.BreakPrice3 = 0.0;
    this.BreakPrice4 = 0.0;
    this.BreakPrice5 = 0.0;
    this.UnitPrice = 0.0;
    this.ProductImage = "";
    this.EstimatedLeadTime = 0;
    this.EstimatedLeadTimeString = "";
    this.ProductURL = "";
    this.ProductNotes = "";
    this.UnitPrice1 = 0.0;
    this.UnitPrice2 = 0.0;
    this.UnitPrice3 = 0.0;
    this.UnitPrice4 = 0.0;
    this.UnitPrice5 = 0.0;
    this.IsV2 = true;
  }

  public QuoteNumber: string;
  public QuoteLine: number;
  public Item: string;
  public Description: string;
  public ShortDesc: string;
  public Price: number;
  public QtyOrdered: number;
  public ExtPrice: number;
  public ConfigString: string;
  public ListPrice: number;
  public PortalStatus: string;
  public DueDate: Date | null;
  public TrackingNumber: string;
  public CarrierCode: string;
  public ShipDate: string;
  public EstShipDate: string;
  public RefNum: string;
  public Followed: boolean;
  public SourceType: string;
  public HTSCode: string;
  public Country: string;
  public OrderDetailRowPointer: string;

  public BreakPrice1: number;
  public BreakPrice2: number;
  public BreakPrice3: number;
  public BreakPrice4: number;
  public BreakPrice5: number;
  public BreakQty1: number;
  public BreakQty2: number;
  public BreakQty3: number;
  public BreakQty4: number;
  public BreakQty5: number;

  public UnitPrice: number;
  public UnitPrice1: number;
  public UnitPrice2: number;
  public UnitPrice3: number;
  public UnitPrice4: number;
  public UnitPrice5: number;


  public ProductImage: string;
  public EstimatedLeadTime: number;
  public EstimatedLeadTimeString: string;
  public ProductURL: string;
  public AssemblyDetails: string[];
  public AssemblyDetailsDB: string;
  public ProductNotes: string;
  public LineNote: string;


  public Sublines: QuoteDetailSubline[];
  public Fees: Fee[];
  public HasOrderNote: boolean;
  public OrderNote: string;
  public Index: number;
  public LineType: string;
  public RowPointer: string;
  public IsV2: boolean;
  public CrateRequired: boolean;
  

  public BuildPricing(pricing: ItemPricing, isV2:boolean) {
    this.BreakPrice1 = pricing.BreakPrice1;
    this.BreakPrice2 = pricing.BreakPrice2;
    this.BreakPrice3 = pricing.BreakPrice3;
    this.BreakPrice4 = pricing.BreakPrice4;
    this.BreakPrice5 = pricing.BreakPrice5;
    this.BreakQty1 = pricing.BreakQty1;
    this.BreakQty2 = pricing.BreakQty2;
    this.BreakQty3 = pricing.BreakQty3;
    this.BreakQty4 = pricing.BreakQty4;
    this.BreakQty5 = pricing.BreakQty5;
    this.ListPrice = pricing.UnitPrice;
    this.ProductURL = pricing.ProductURL;
    this.ProductImage = pricing.ProductImageURL;

    if (this.BreakQty1 == 0) {
      //Must not be any pricing set up
      this.BreakQty1 = 1;
      this.BreakPrice1 = 0;
      this.BreakQty2 = null;
      this.BreakQty3 = null;
      this.BreakQty4 = null;
      this.BreakQty5 = null;
    }

    this.UnitPrice = pricing.UnitPrice;
    this.EstimatedLeadTimeString = pricing.EstimatedLeadTime;
    //this.EstLeadTime = pricing.EstimatedLeadTime;

    if (isV2) {
      this.UnitPrice1 = (this.ListPrice + ((this.BreakPrice1 / 100.00) * this.ListPrice));
    }
    else {
      this.UnitPrice1 = 0.0;
    }
    if (this.BreakPrice2 != 0 && isV2) {
      this.UnitPrice2 = (this.ListPrice + ((this.BreakPrice2 / 100.00) * this.ListPrice));
    } else if (isV2) {
      this.UnitPrice2 = 0.0;
    }

    if (this.BreakPrice3 != 0 && isV2) {
      this.UnitPrice3 = (this.ListPrice + ((this.BreakPrice3 / 100.00) * this.ListPrice));
    } else if (isV2) {
      this.UnitPrice3 = 0.0;
    }

    if (this.BreakPrice4 != 0 && isV2) {
      this.UnitPrice4 = (this.ListPrice + ((this.BreakPrice4 / 100.00) * this.ListPrice));
    } else if (isV2) {
      this.UnitPrice4 = 0.0;
    }

    if (this.BreakPrice5 != 0 && isV2) {
      this.UnitPrice5 = (this.ListPrice + ((this.BreakPrice5 / 100.00) * this.ListPrice));
    } else if (isV2) {
      this.UnitPrice5 = 0.0;
    }

    //this.UnitPrice1 = (this.ListPrice + ((this.BreakPrice1 / 100.00) * this.ListPrice));
    //this.UnitPrice2 = (this.ListPrice + ((this.BreakPrice2 / 100.00) * this.ListPrice));
    //this.UnitPrice3 = (this.ListPrice + ((this.BreakPrice3 / 100.00) * this.ListPrice));
    //this.UnitPrice4 = (this.ListPrice + ((this.BreakPrice4 / 100.00) * this.ListPrice));
    //this.UnitPrice5 = (this.ListPrice + ((this.BreakPrice5 / 100.00) * this.ListPrice));
  }

  public BuildFromExisting(qd: QuoteDetail, isV2: boolean): QuoteDetail {
    this.QuoteNumber = qd.QuoteNumber;
    this.QuoteLine = qd.QuoteLine;
    this.Item = qd.Item;
    this.ConfigString = qd.ConfigString;
    this.ProductImage = qd.ProductImage;
    this.Fees = qd.Fees;
    this.Index = qd.Index;
    this.LineNote = qd.LineNote;
    this.AssemblyDetails = qd.AssemblyDetails;
    this.AssemblyDetailsDB = qd.AssemblyDetailsDB;
    this.OrderDetailRowPointer = qd.OrderDetailRowPointer;
    if ((this.AssemblyDetails == null || this.AssemblyDetails.length == 0) && this.AssemblyDetailsDB != null) {
      this.AssemblyDetails = this.AssemblyDetailsDB.split("<br />");
    }
    this.LineType = qd.LineType;
    this.Description = qd.Description;
    this.ShortDesc = qd.ShortDesc;
    this.Price = qd.Price;
    this.QtyOrdered = qd.QtyOrdered;
    this.ExtPrice = qd.ExtPrice;
    this.ListPrice = qd.ListPrice;
    this.PortalStatus = qd.PortalStatus;
    this.DueDate = qd.DueDate;
    this.TrackingNumber = qd.TrackingNumber;
    this.CarrierCode = qd.CarrierCode;
    this.ShipDate = qd.ShipDate;
    this.EstShipDate = qd.EstShipDate;
    this.RefNum = qd.RefNum;
    this.Followed = qd.Followed;
    this.SourceType = qd.SourceType;
    this.HTSCode = qd.HTSCode;
    this.Country = qd.Country;

    this.UnitPrice = qd.UnitPrice;
    this.ProductImage = qd.ProductImage;
    this.EstimatedLeadTime = qd.EstimatedLeadTime;
    this.EstimatedLeadTimeString = qd.EstimatedLeadTimeString;
    this.ProductURL = qd.ProductURL;
    this.ProductNotes = qd.ProductNotes;
    this.BreakPrice1 = qd.BreakPrice1;
    this.BreakPrice2 = qd.BreakPrice2;
    this.BreakPrice3 = qd.BreakPrice3;
    this.BreakPrice4 = qd.BreakPrice4;
    this.BreakPrice5 = qd.BreakPrice5;
    this.BreakQty1 = qd.BreakQty1;
    this.BreakQty2 = qd.BreakQty2;
    this.BreakQty3 = qd.BreakQty3;
    this.BreakQty4 = qd.BreakQty4;
    this.BreakQty5 = qd.BreakQty5;
    this.IsV2 = isV2;
    this.CrateRequired = qd.CrateRequired;
    if (this.BreakPrice1 != 0 && this.IsV2) {
      this.UnitPrice1 = (this.ListPrice + ((this.BreakPrice1 / 100.00) * this.ListPrice));
    }
    else if (!isV2) {
      this.UnitPrice1 = qd.UnitPrice1;
    }
    else {
      this.UnitPrice1 = 0.0;
    }
    if (this.BreakPrice2 != 0 && this.IsV2) {
      this.UnitPrice2 = (this.ListPrice + ((this.BreakPrice2 / 100.00) * this.ListPrice));
    } else if (!isV2) {
      this.UnitPrice2 = qd.UnitPrice2;
    }
    else {
      this.UnitPrice2 = 0.0;
    }

    if (this.BreakPrice3 != 0 && this.IsV2) {
      this.UnitPrice3 = (this.ListPrice + ((this.BreakPrice3 / 100.00) * this.ListPrice));
    } else if (!isV2) {
      this.UnitPrice3 = qd.UnitPrice3;
    }
    else {
      this.UnitPrice3 = 0.0;
    }
    if (this.BreakPrice4 != 0 && this.IsV2) {
      this.UnitPrice4 = (this.ListPrice + ((this.BreakPrice4 / 100.00) * this.ListPrice));
    } else if (!isV2) {
      this.UnitPrice4 = qd.UnitPrice4;
    }
    else {
      this.UnitPrice4 = 0.0;
    }
    if (this.BreakPrice5 != 0 && this.IsV2) {
      this.UnitPrice5 = (this.ListPrice + ((this.BreakPrice5 / 100.00) * this.ListPrice));
    } else if (!isV2) {
      this.UnitPrice5 = qd.UnitPrice5;
    }
    else {
      this.UnitPrice5 = 0.0;
    }
    

    return this;
  }

  public GetBreakPrice(level: number): string {
    var retString = "";
    switch (level) {
      case 0:
        if (this.BreakPrice1 != 0.0 && this.ListPrice > 0.0 && this.IsV2) {
          retString = (this.ListPrice + ((this.BreakPrice1 / 100.00) * this.ListPrice)).toFixed(2)
        }
        else if (!this.IsV2) {
          retString = this.UnitPrice1.toFixed(2);
        }
        else {
          retString ="0.0";
        }
        break;
      case 1:
        if (this.BreakPrice2 != 0.0 && this.ListPrice > 0.0 && this.IsV2) {
          retString = (this.ListPrice + ((this.BreakPrice2 / 100.00) * this.ListPrice)).toFixed(2)
        }
        else if (!this.IsV2) {
          retString = this.UnitPrice2.toFixed(2);
        }
        else {
          retString = "0.0";
        }
        break;
      case 2:
        if (this.BreakPrice3 != 0.0 && this.ListPrice > 0.0 && this.IsV2) {
          retString = (this.ListPrice + ((this.BreakPrice3 / 100.00) * this.ListPrice)).toFixed(2)
        }
        else if (!this.IsV2) {
          retString = this.UnitPrice3.toFixed(2);
        }
        else {
          retString = "0.0";
        }
        break;
      case 3:
        if (this.BreakPrice4 != 0.0 && this.ListPrice > 0.0 && this.IsV2) {
          retString = (this.ListPrice + ((this.BreakPrice4 / 100.00) * this.ListPrice)).toFixed(2)
        }
        else if (!this.IsV2) {
          retString = this.UnitPrice4.toFixed(2);
        }
        else {
          retString = "0.0";
        }
        break;
      case 4:
        if (this.BreakPrice5 != 0.0 && this.ListPrice > 0.0 && this.IsV2) {
          retString = (this.ListPrice + ((this.BreakPrice5 / 100.00) * this.ListPrice)).toFixed(2)
        } else if (!this.IsV2) {
          retString = this.UnitPrice5.toFixed(2);
        }
        else {
          retString = "0.0";
        }
        break;
      default:
        retString = "0.0";
        break;
    }
    return retString;
  }

  public GetBreakQtyString(level: number): string {
    var QtyMessage = "";
    if (level == 0 && this.BreakQty1 > 0) {
      QtyMessage = this.BreakQty1 + (this.BreakQty2 > 0 ? "-" + (this.BreakQty2 - 1).toString() : "+");
    } else if (level == 1 && this.BreakQty2 > 0) {
      QtyMessage = this.BreakQty2 + (this.BreakQty3 > 0 ? "-" + (this.BreakQty3 - 1).toString() : "+");
    } else if (level == 2 && this.BreakQty3 > 0) {
      QtyMessage = this.BreakQty3 + (this.BreakQty4 > 0 ? "-" + (this.BreakQty4 - 1).toString() : "+");
    } else if (level == 3 && this.BreakQty4 > 0) {
      QtyMessage = this.BreakQty4 + (this.BreakQty5 > 0 ? "-" + (this.BreakQty5 - 1).toString() : "+");
    } else if (level == 4 && this.BreakQty5 > 0) {
      QtyMessage = this.BreakQty5 + "+";
    }
    return QtyMessage;
  }

  public GetExtPrice(): string {
    var retPrice = 0.0;
    if (this.QtyOrdered > 0.0) {
      if (this.IsV2) {
        if (this.QtyOrdered < this.BreakQty1) {
          retPrice = this.ListPrice;
        }
        else if (this.QtyOrdered < this.BreakQty2) {
          retPrice = (this.ListPrice + ((this.BreakPrice1 / 100.00) * this.ListPrice))
        }
        else if (this.QtyOrdered < this.BreakQty3) {
          retPrice = (this.ListPrice + ((this.BreakPrice2 / 100.00) * this.ListPrice))
        }
        else if (this.QtyOrdered < this.BreakQty4) {
          retPrice = (this.ListPrice + ((this.BreakPrice3 / 100.00) * this.ListPrice))
        }
        else if (this.QtyOrdered < this.BreakQty5) {
          retPrice = (this.ListPrice + ((this.BreakPrice4 / 100.00) * this.ListPrice))
        }
        else if (this.QtyOrdered >= this.BreakQty5) {
          retPrice = (this.ListPrice + ((this.BreakPrice5 / 100.00) * this.ListPrice))
        }
      }
      else {
        if (this.QtyOrdered < this.BreakQty1) {
          retPrice = this.ListPrice == 0.0 ? this.UnitPrice1 : this.ListPrice;
        }
        else if (this.QtyOrdered < this.BreakQty2) {
          retPrice = this.UnitPrice1;
        }
        else if (this.QtyOrdered < this.BreakQty3) {
          retPrice = this.UnitPrice2;
        }
        else if (this.QtyOrdered < this.BreakQty4) {
          retPrice = this.UnitPrice3;
        }
        else if (this.QtyOrdered < this.BreakQty5) {
          retPrice = this.UnitPrice4;
        }
        else if (this.QtyOrdered >= this.BreakQty5) {
          retPrice = this.UnitPrice5;
        }
      }
      retPrice = retPrice * this.QtyOrdered;
    }

    return retPrice.toFixed(2);

  }

}
